<template>
  <Fragment>
    <AppHeader />
    <slot />
    <AppFooter />
  </Fragment>
</template>

<script>
import AppFooter from "@/components/navigation/AppFooter.vue";
import AppHeader from "@/components/navigation/AppHeader.vue";
import store from "@/store";
import axios from "axios";

import { Fragment } from "vue-frag";

export default {
  name: "homeLayout",
  computed: {
    allProductsInsightsBatch() {
      const insightsBatches = Object.values(store.state.productsInsightsBatch);
      const allInsights = insightsBatches.flatMap((x) => x);
      return allInsights;
    },
    allCamapignsInsightsBatch() {
      const campaignsBatches = Object.values(
        store.state.campaignsInsightsBatch
      );
      const allCampaigns = campaignsBatches.flatMap((x) => x);
      return allCampaigns;
    },
  },
  data() {
    return {
      timer: null,
      campTimer: null,
    };
  },
  created() {
    this.startTimer();
    this.campaignTimer();
  },
  components: { AppHeader, AppFooter, Fragment },
  methods: {
    saveBatch() {
      if (store.state.isSavingProductBatch) return;

      const productsInsightsBatchMap = store.state.productsInsightsBatch;
      store.commit("setIsSavingProductBatch", true);

      for (let type in productsInsightsBatchMap) {
        const batchSnapshot = [...store.state.productsInsightsBatch[type]];

        axios
          .post("products/insights", {
            type,
            product_id: batchSnapshot,
          })
          .then(() => {
            const updatedBatch = store.state.productsInsightsBatch[
              type
            ]?.filter((productId) => !batchSnapshot.includes(productId));

            store.commit("setProductsInsightsBatch", {
              batch: updatedBatch,
              type,
            });
            store.commit("setIsSavingProductBatch", false);
          })
          .catch(() => {
            store.commit("setIsSavingProductBatch", false);
          });
      }
    },
    saveCampaignBatch() {
      if (store.state.isSavingCampaignBatch) return;

      const campaignsInsightsBatchMap = store.state.campaignsInsightsBatch;
      store.commit("setIsSavingCampaignBatch", true);

      for (let type in campaignsInsightsBatchMap) {
        const batchSnapshot = [...store.state.campaignsInsightsBatch[type]];

        axios
          .post("campaigns/insights", {
            type,
            campaign_uid: batchSnapshot,
          })
          .then(() => {
            const updatedBatch = store.state.campaignsInsightsBatch[
              type
            ]?.filter((productId) => !batchSnapshot.includes(productId));

            store.commit("setCampaignsInsightsBatch", {
              batch: updatedBatch,
              type,
            });
            store.commit("setIsSavingCampaignBatch", false);
          })
          .catch(() => {
            store.commit("setIsSavingCampaignBatch", false);
          });
      }
    },
    campaignTimer() {
      if (this.campTimer) {
        clearTimeout(this.campTimer);
      }

      this.campTimer = setTimeout(() => {
        if (this.allCamapignsInsightsBatch.length) {
          this.saveCampaignBatch();
        }
      }, 5000);
    },
    startTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        if (this.allProductsInsightsBatch.length) {
          this.saveBatch();
        }
      }, 5000);
    },
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (this.campTimer) {
      clearTimeout(this.campTimer);
    }
  },
  watch: {
    allProductsInsightsBatch(value) {
      if (value.length >= 20) {
        this.saveBatch();
      } else {
        this.startTimer();
      }
    },
    allCampaignsInsightsBatch(value) {
      if (value.length >= 10) {
        this.saveCampaignBatch();
      } else {
        this.campaignTimer();
      }
    },
  },
};
</script>
